document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('#header');
  const dropdowns = document.querySelectorAll('.header__nav-dropdown');

  function setDropdownTop() {
    if (!header) return;
    const top = header.getBoundingClientRect().bottom;
    dropdowns.forEach(dd => {
      dd.style.top = `${top}px`;
    });
  }

  setDropdownTop();
  window.addEventListener('scroll', setDropdownTop);
  window.addEventListener('resize', setDropdownTop);
});
